"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var __aws_sdk_bucket_endpoint_middleware = require("@aws-sdk/bucket-endpoint-middleware");
var __aws_sdk_middleware_stack = require("@aws-sdk/middleware-stack");
var PutBucketMetricsConfiguration_1 = require("../model/PutBucketMetricsConfiguration");
var PutBucketMetricsConfigurationCommand = /** @class */ (function () {
    function PutBucketMetricsConfigurationCommand(input) {
        this.input = input;
        this.model = PutBucketMetricsConfiguration_1.PutBucketMetricsConfiguration;
        this.middlewareStack = new __aws_sdk_middleware_stack.MiddlewareStack();
    }
    PutBucketMetricsConfigurationCommand.prototype.resolveMiddleware = function (clientStack, configuration) {
        var handler = configuration.handler;
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {},
            model: this.model
        };
        stack.add(__aws_sdk_bucket_endpoint_middleware.bucketEndpointMiddleware({
            forcePathStyle: configuration.forcePathStyle,
            preformedBucketEndpoint: configuration.bucketEndpoint,
            useAccelerateEndpoint: configuration.useAccelerateEndpoint,
            useDualstackEndpoint: configuration.useDualstackEndpoint
        }), {
            step: "build",
            priority: 0
        });
        return stack.resolve(handler(handlerExecutionContext), handlerExecutionContext);
    };
    return PutBucketMetricsConfigurationCommand;
}());
exports.PutBucketMetricsConfigurationCommand = PutBucketMetricsConfigurationCommand;
//# sourceMappingURL=PutBucketMetricsConfigurationCommand.js.map